import axios from "axios"
import * as env from "../constants/env"


/* Get Profile Data */
export const profile = () => {
    const uri = `${env.startpoint}profile/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Get Variables — the current admin and the role the menu is built from */
export const variables = (token) => {
    const uri = `${env.startpoint}profile/variables`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Save Data */
export const save = (data) => {
    const uri = `${env.startpoint}profile/save`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Change Password */
export const password = (data) => {
    const uri = `${env.startpoint}profile/password`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Upload Image */
export const upload = (data) => {
    const uri = `${env.startpoint}profile/upload`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Remove Image */
export const remove = (data) => {
    const uri = `${env.startpoint}profile/remove`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Get History */
export const history = (page) => {
    const uri = `${env.startpoint}profile/history?page=${page}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}